<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100"
                        fixed-header height="calc(100vh - 300px)">
                        <template v-slot:item="{ item }">
                            <tr>
                                <td>{{ item.ID }}</td>
                                <td>{{ item.Name }}</td>
                                <td>{{ item.IsHidden ? 'Không sử dụng' : '' }}</td>
                                <td>
                                    {{ item.CreatedDate | display_date}}
                                </td>
                                <td class="text-center">
                                    <table-action-buttons :actions="getItemActions(item)"></table-action-buttons>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogItem" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="title">Chi tiết loại hàng</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md pa-0>
                <v-layout row wrap>
                  <v-flex lg12>
                    <v-text-field label="Tên loại hàng" v-model="currentItem.Name" class="input-group--focused"></v-text-field>
                  </v-flex>
                  <v-flex lg12>
                    <v-switch label="Không sử dụng" v-model="currentItem.IsHidden" class="input-group--focused"></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1 white--text" @click="dialogItem = false">Đóng</v-btn>
              <v-btn @click="editItem" v-if="adminRole || managerRole">Lưu lại</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-container>
    </template>
    
    <script>
    import { mapState } from "vuex";
    import configs from "@/configs";
    import Filtering from "@/components/Filtering";
    import _ from "lodash";
    
    export default {
        components: {
            "hpo-filter": Filtering
        },
        data() {
            return {
                viewName: "productType_list",
                dialogItem: false,
                headers: [
                    {
                        text: this.$t('table_headers.id'),
                        value: "ID",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Number"]
                    },
                    {
                        text: this.$t('table_headers.product_type_name'),
                        value: "Name",
                        filterable: true,
                        quickSearch: true,
                        dataType: configs.DATA_TYPE["String"]
                    },
                    {
                        text: this.$t('table_headers.is_hidden'),
                        value: "IsHidden",
                        filterable: true,
                        values: [ {"value": 0, "name": this.$t('table_headers.in_use')}, {"value": 1, "name": this.$t('table_headers.not_in_use')} ],
                        dataType: configs.DATA_TYPE["Enum"]
                    },
                    {
                        text: this.$t('table_headers.created_date'),
                        value: "CreatedDate",
                        filterable: true,
                        dataType: configs.DATA_TYPE["Date"]
                    },
                    {
                        text: "",
                        value: "",
                        align: "center",
                        sortable: false,
                        filterable: false
                    }
                ],
                pagination: _.cloneDeep(configs.PAGINATION),
                items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
                filterConditions: [],
                quickFilterConditions: [],
                requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            };
        },
        watch: {
            pagination: {
                handler: function (val, oldVal) {
                    let filterConditions = this.$store.state.commons.filterConditions;
                    this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                    this.filter_data();
                },
                deep: true
            },
            loading() {
              this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.adminRole && !this.managerRole});
            }
        },
        computed: {
            ...mapState({
                items: state => state.productType.all.data,
                total_rows: state => state.productType.all.total,
                loading: state => state.productType.loading,
                currentItem: state => state.productType.selected
            }),
            adminRole() {
                return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
            },
            managerRole() {
                return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Manager;
            }
        },
        methods: {
            getItemActions(item) {
                return [
                    { label: this.$t('actions.edit'), variant: 'primary', onClick: () => this.openItem(item.ID) },
                    { label: this.$t('actions.delete'), variant: 'danger-outline', hidden: !(this.adminRole || this.managerRole), onClick: () => this.deleteItem(item.ID) }
                ];
            },
            filter_data: function () {
                var param = {
                    pagination: this.pagination,
                    filter: this.filterConditions,
                    quickFilter: this.quickFilterConditions
                };
                this.$store.dispatch("productType/getList", param);
            },
            applyFilter(filterConditions) {
                let sortBy = this.pagination.sortBy
                let sortDesc = this.pagination.sortDesc
                this.pagination = configs.PAGINATION;
                this.pagination.sortBy = sortBy;
                this.pagination.sortDesc = sortDesc;
                this.filterConditions = filterConditions;
                this.filter_data();
            },
            quickFilter(filterConditions) {
                this.quickFilterConditions = filterConditions;
                this.filter_data();
            },
            openItem: function (id) {
                if(!id) {
                    this.$store.commit("productType/setDetail", {'ID': id});
                }
                else {
                    this.$store.dispatch("productType/getDetail", id);
                }
                this.dialogItem = true;
            },
            deleteItem: function(id) {
                window.getApp.$emit('REQUEST_DELETE_DATA', id);
            },
            editItem() {
                this.$store.dispatch("productType/setDetail", {
                    'data': {...this.currentItem},
                    'id': this.currentItem.ID
                });
                this.dialogItem = false;
            }
        },
        mounted() {
            this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: false});
            this.$root.$on("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
                this.$store.dispatch("productType/removeDetail", id);
            });
        },
        beforeDestroy() {
            this.$root.$off("REQUEST_CREATE_DATA", this.openItem);
            this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
            this.$root.$off("CONFIRMED_REMOVE_DATA");
        }
    };
    </script>
